import React from 'react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { Check, ShieldCheck, Sparkles, Coffee, TrendingUp } from 'lucide-react';
function handleBuyClick() {
  if ((window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      value: 6.36,
      currency: 'USD',
      content_name: 'Escape 9-a-5 PDF'
    });
  }
}
export function PriceSection() {
  return <section id="precios" className="pt-6 pb-24 bg-brand-light relative" data-id="element-119">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="text-4xl font-heading font-medium text-brand-dark mb-6" data-id="element-122">
            ¿Cuánto vale tu{' '}
            <span className="text-brand-primary italic font-bold" data-id="element-123">
              libertad
            </span>
            ?
          </h2>
          <p className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-124">
            Podría cobrar $97 por esta información — es menos de lo que ganarás
            en tu primer cierre. Pero quiero que el precio nunca sea la razón
            por la que no cambies tu vida.
          </p>
        </div>

        {/* Psychological comparison bar */}
        <div className="grid grid-cols-3 gap-3 mb-8 text-center" data-id="element-125">
          <div className="bg-white rounded-2xl p-4 border border-rose-100 shadow-sm" data-id="element-126">
            <p className="text-xs text-brand-muted uppercase tracking-wider mb-1" data-id="element-127">
              Café Starbucks
            </p>
            <p className="text-2xl font-heading font-bold text-brand-muted/60 line-through" data-id="element-128">
              $7+
            </p>
            <p className="text-xs text-brand-muted mt-1" data-id="element-129">Se acaba en 10 min</p>
          </div>
          <div className="bg-brand-primary rounded-2xl p-4 border-2 border-brand-secondary shadow-xl shadow-rose-300/30 scale-105 relative" data-id="element-130">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-secondary text-white text-[10px] font-bold px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-131">
              ✨ TU INVERSIÓN
            </div>
            <p className="text-xs text-rose-200 uppercase tracking-wider mb-1" data-id="element-132">
              Este Método
            </p>
            <p className="text-2xl font-heading font-bold text-white" data-id="element-133">$6.36</p>
            <p className="text-xs text-rose-200 mt-1" data-id="element-134">Cambia tu vida</p>
          </div>
          <div className="bg-white rounded-2xl p-4 border border-rose-100 shadow-sm" data-id="element-135">
            <p className="text-xs text-brand-muted uppercase tracking-wider mb-1" data-id="element-136">
              30 min de trabajo
            </p>
            <p className="text-2xl font-heading font-bold text-brand-muted/60 line-through" data-id="element-137">
              $7.50
            </p>
            <p className="text-xs text-brand-muted mt-1" data-id="element-138">Al salario mínimo</p>
          </div>
        </div>

        <Card variant="highlight" className="relative overflow-visible" data-id="element-139">
          {/* Badge */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center" data-id="element-140">
            <span className="bg-gradient-to-r from-brand-primary to-brand-secondary text-white px-8 py-3 rounded-full font-bold text-sm uppercase tracking-widest shadow-lg shadow-rose-500/30 inline-flex items-center gap-2" data-id="element-141">
              <Sparkles className="w-4 h-4" data-id="element-142" />
              Oferta de Lanzamiento — 93% OFF
            </span>
          </div>

          <div className="p-8 sm:p-14" data-id="element-143">
            <div className="text-center mb-10 border-b border-rose-100 pb-10" data-id="element-144">
              <p className="text-brand-muted/50 line-through text-lg mb-1" data-id="element-145">
                Precio Regular: $97.00
              </p>
              <p className="text-brand-muted/40 text-sm mb-4" data-id="element-146">
                Otros cobran hasta $47 por solo una parte de esto
              </p>
              <div className="flex items-start justify-center gap-1" data-id="element-147">
                <span className="text-3xl font-bold text-brand-primary mt-3" data-id="element-148">
                  $
                </span>
                <span className="text-8xl font-heading font-bold text-brand-dark leading-none" data-id="element-149">
                  6
                </span>
                <span className="text-4xl font-heading font-bold text-brand-primary mt-4" data-id="element-150">
                  .36
                </span>
              </div>
              <p className="text-brand-muted text-sm mt-2" data-id="element-151">USD · Pago único</p>
              <div className="flex items-center justify-center gap-2 mt-4" data-id="element-152">
                <TrendingUp className="w-4 h-4 text-green-600" data-id="element-153" />
                <p className="text-green-600 font-bold text-sm" data-id="element-154">
                  Tu primer cierre te devuelve hasta 31x tu inversión
                </p>
              </div>
              <p className="text-brand-primary font-bold mt-3 bg-rose-50 inline-block px-4 py-1 rounded-lg text-sm uppercase tracking-wide" data-id="element-155">
                Acceso de por vida · Descarga inmediata
              </p>
            </div>

            {/* Value stack */}
            <div className="space-y-4 mb-8" data-id="element-156">
              <p className="text-xs text-brand-muted uppercase tracking-widest font-bold text-center mb-5" data-id="element-157">
                Lo que recibes hoy:
              </p>
              <div className="flex items-center justify-between" data-id="element-158">
                <div className="flex items-center" data-id="element-159">
                  <div className="bg-brand-soft rounded-full p-1.5 mr-4" data-id="element-160">
                    <Check className="w-4 h-4 text-brand-primary" data-id="element-161" />
                  </div>
                  <span className="text-brand-dark font-medium" data-id="element-162">
                    El Script de Oro
                  </span>
                </div>
                <span className="text-brand-muted/50 line-through text-sm" data-id="element-163">
                  $37
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-164">
                <div className="flex items-center" data-id="element-165">
                  <div className="bg-brand-soft rounded-full p-1.5 mr-4" data-id="element-166">
                    <Check className="w-4 h-4 text-brand-primary" data-id="element-167" />
                  </div>
                  <span className="text-brand-dark font-medium" data-id="element-168">
                    Infiltración en Instagram
                  </span>
                </div>
                <span className="text-brand-muted/50 line-through text-sm" data-id="element-169">
                  $27
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-170">
                <div className="flex items-center" data-id="element-171">
                  <div className="bg-brand-soft rounded-full p-1.5 mr-4" data-id="element-172">
                    <Check className="w-4 h-4 text-brand-primary" data-id="element-173" />
                  </div>
                  <span className="text-brand-dark font-medium" data-id="element-174">
                    Plan de Acción de 14 Días
                  </span>
                </div>
                <span className="text-brand-muted/50 line-through text-sm" data-id="element-175">
                  $23
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-176">
                <div className="flex items-center" data-id="element-177">
                  <div className="bg-brand-soft rounded-full p-1.5 mr-4" data-id="element-178">
                    <Check className="w-4 h-4 text-brand-primary" data-id="element-179" />
                  </div>
                  <span className="text-brand-dark font-medium" data-id="element-180">
                    Bonus: Lista de Nichos Rentables
                  </span>
                </div>
                <span className="text-brand-muted/50 line-through text-sm" data-id="element-181">
                  $10
                </span>
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-rose-100" data-id="element-182">
                <span className="font-bold text-brand-dark" data-id="element-183">Valor Total</span>
                <div className="flex items-center gap-3" data-id="element-184">
                  <span className="text-brand-muted/50 line-through" data-id="element-185">$97</span>
                  <span className="font-bold text-brand-primary text-lg" data-id="element-186">
                    $6.36
                  </span>
                </div>
              </div>
            </div>

            <Button size="lg" href="https://www.betterbysteps.com/cart/44215868555357:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full text-base sm:text-lg py-6 sm:py-8 animate-pulse-rose shadow-xl hover:shadow-2xl transform transition-all hover:-translate-y-1" data-id="element-187">
              DESCARGAR AHORA — SOLO $6.36
            </Button>

            <p className="text-center text-xs text-brand-muted mt-4 italic" data-id="element-188">
              "Menos que un café. Más que un cambio de vida."
            </p>

            <div className="mt-6 flex items-center justify-center text-sm text-brand-muted" data-id="element-189">
              <ShieldCheck className="w-5 h-5 mr-2 text-brand-primary" data-id="element-190" />
              <span data-id="element-191">Pago 100% Seguro · Garantía 30 días</span>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}